import Styled from "./styles";
import Disclaimer from "./Disclaimer";
import { Link } from "react-router-dom";
// import logo from "../../../assets/new-york-state-vector-logo-white.svg";

const Footer = () => {
  return (
    <Styled>
      <Disclaimer />
      <footer className="footer">
        <div role="navigation" aria-label="footer" className="footer-container">
          <div role="list">
            <div role="none" className="level-one">
              <span role="listitem" className="list-item-wrapper">
                <Link to="/"> Home </Link>
              </span> <span aria-hidden>|</span> 
              <span role="listitem" className="list-item-wrapper">
                <Link to="/#search"> Search </Link>
              </span> <span aria-hidden>|</span>
              <span role="listitem" className="list-item-wrapper"> 
                <Link to="/#physician-profile">
                  {" "}
                  Physicians: Update your profile{" "}
                </Link>{" "}
              </span><span aria-hidden>|</span>
              <span role="listitem" className="list-item-wrapper">
                <Link to="/search-tips"> Search Tips </Link>
              </span>
          </div>
          <div role="none" className="level-two">
             <span role="listitem" className="list-item-wrapper"><Link to="/dictionary"> Dictionary </Link> </span> <span aria-hidden>|</span>
             <span role="listitem" className="list-item-wrapper"><Link to="/contact-us"> Contact Us </Link> </span> <span aria-hidden>|</span>
             <span role="listitem" className="list-item-wrapper"><Link to="/feedback"> Give Us Your Feedback </Link> </span> <span aria-hidden>|</span>
             <span role="listitem" className="list-item-wrapper"><Link to="/privacy-policy"> Privacy Policy </Link> </span> <span aria-hidden>|</span>
             <span role="listitem" className="list-item-wrapper">
              <a
                href="https://www.health.ny.gov/about/privacy.htm"
                target="_blank"
                rel="noreferrer"
              >
                {" "}
                Privacy Policy{" "}
              </a>
              </span> 
          </div>
          </div>  
          <div className="lang-links" role="list">
            <span role="listitem"> <Link to="/language-assistance" title="Chinese language assistance"> 中文 </Link> </span> 
            <span role="listitem"> <Link to="/language-assistance" title="Spanish language assistance"> Español </Link> </span>
            <span role="listitem"> <Link to="/language-assistance" title="Russian language assistance"> Русский </Link> </span>
            <span role="listitem"> <Link to="/language-assistance" title="Kreyol language assistance"> Kreyòl </Link> </span>
          </div>
          <div role="list">
            <div role="none" className="list-item-wrapper">
              <a
                role="listitem"
                href="http://www.health.ny.gov/"
                target="_blank"
                rel="noreferrer"
              >
                {" "}
                Department of Health Home Page{" "}
              </a>{" "}
            <span aria-hidden>|</span>
              <a
                role="listitem"
                href="http://www.health.ny.gov/nysdoh/healthinfo/index.htm"
                target="_blank"
                rel="noreferrer"
              >
                {" "}
                Center for Consumer Health Care Information{" "}
              </a>
            </div>
            <div role="none" className="list-item-wrapper">
              <a
                role="listitem"
                href="http://www.op.nysed.gov/opsearches.htm"
                target="_blank"
                rel="noreferrer"
              >
                {" "}
                New York State Education Office of the Professions On-line
                Verification Searches
              </a>
            </div>
            <div role="none" className="list-item-wrapper">
              <a
                role="listitem"
                href="https://profiles.health.ny.gov/hospital"
                target="_blank"
                rel="noreferrer"
              >
                {" "}
                New York State Hospital Profile{" "}
              </a>{" "}
              <span aria-hidden>|</span>
              <a
                role="listitem"
                href="http://iapps.courts.state.ny.us/webcivil/ecourtsMain"
                target="_blank"
                rel="noreferrer"
              >
                {" "}
                New York State Unified Court System{" "}
              </a>
            </div>
          </div>
        </div>
      </footer>
    </Styled>
  );
};
export default Footer;
